export const environment = {
    webappsRootURL: 'https://project1apps.epa.ohio.gov',
    ebizRootURL: 'https://epaproject1apps.epa.ohio.gov',
    clientID: '9ee5d171-1191-477f-a8c0-f410396ea68c',
    redirectURI: 'https://gwqcp.project1.epa.ohio.gov/',
};
